import React from 'react';
import { CVData, TemplateColors } from '../../types';
import { BaseTemplate } from './BaseTemplate';
import { generateTemplateColors } from '../../lib/colorUtils';

interface Template1Props {
  data: CVData;
  pageNumber?: number;
  customColor?: string;
}

export function Template1({ data, pageNumber = 1, customColor }: Template1Props) {
  // Usar el color personalizado si está disponible, o el color por defecto
  const baseColor = customColor || '#4B6A9B';
  
  console.log("Template1 - Color personalizado recibido:", customColor);
  console.log("Template1 - Color base utilizado:", baseColor);
  
  // Generar colores derivados basados en el color principal
  const colors = generateTemplateColors(baseColor);
  
  console.log("Template1 - Colores generados:", colors);

  // Verificamos si hay cursos para mostrar
  const hasCourses = data.courses && data.courses.length > 0;
  
  // Verificamos si es una página de continuación
  const isContinuationPage = (data as any).isContinuationPage || false;
  
  // Verificamos si es una página de continuación específica del caso 3
  const isCase3ContinuationPage = (data as any).isCase3ContinuationPage || false;
  
  // Verificamos si es una página de continuación específica del caso 4
  const isCase4ContinuationPage = (data as any).isCase4ContinuationPage || false;
  
  // Verificamos si es la segunda página del caso 5 (3 experiencias)
  const isCase5SecondPage = (data as any).isCase5SecondPage || false;
  
  // Verificamos si es la tercera página del caso 5 (solo cursos)
  const isCase5ThirdPage = (data as any).isCase5ThirdPage || false;
  
  // Verificamos si es la segunda o tercera página del caso 6
  const isCase6SecondPage = (data as any).isCase6SecondPage || false;
  const isCase6ThirdPage = (data as any).isCase6ThirdPage || false;
  
  // Verificamos si es la segunda página del caso 7
  const isCase7SecondPage = (data as any).isCase7SecondPage || false;
  
  // Verificamos si es la tercera página del caso 7
  const isCase7ThirdPage = (data as any).isCase7ThirdPage || false;
  
  // Verificamos si es la segunda, tercera o cuarta página del caso 8
  const isCase8SecondPage = (data as any).isCase8SecondPage || false;
  const isCase8ThirdPage = (data as any).isCase8ThirdPage || false;
  const isCase8FourthPage = (data as any).isCase8FourthPage || false;
  
  // Verificamos si es una página de continuación con experiencia + cursos
  const isExperiencePlusCourses = (data as any).isExperiencePlusCourses || false;
  
  // Verificamos si es una página de continuación que incluye experiencias
  const isContinuationWithExperiences = (data as any).isContinuationWithExperiences || false;
  
  // Verificamos si es una página de sólo cursos (caso 2 o caso 5 tercera página o caso 8 cuarta página)
  const isOnlyCoursesPage = isCase5ThirdPage || isCase8FourthPage || (data as any).isOnlyCoursesPage || false;

  // Verificamos si es una página de continuación para cualquier caso
  const isAnyCaseContinuationPage = isCase3ContinuationPage || isCase4ContinuationPage || 
                                   isCase5SecondPage || isCase5ThirdPage || 
                                   isCase6SecondPage || isCase6ThirdPage || 
                                   isCase7SecondPage || isCase7ThirdPage ||
                                   isCase8SecondPage || isCase8ThirdPage || isCase8FourthPage;

  console.log("Template1 - Es continuación:", isContinuationPage);
  console.log("Template1 - Es continuación Caso 3:", isCase3ContinuationPage);
  console.log("Template1 - Es continuación Caso 4:", isCase4ContinuationPage);
  console.log("Template1 - Es página 2 Caso 5:", isCase5SecondPage);
  console.log("Template1 - Es página 3 Caso 5:", isCase5ThirdPage);
  console.log("Template1 - Es página 2 Caso 6:", isCase6SecondPage);
  console.log("Template1 - Es página 3 Caso 6:", isCase6ThirdPage);
  console.log("Template1 - Es página 2 Caso 7:", isCase7SecondPage);
  console.log("Template1 - Es página 3 Caso 7:", isCase7ThirdPage);
  console.log("Template1 - Es página 2 Caso 8:", isCase8SecondPage);
  console.log("Template1 - Es página 3 Caso 8:", isCase8ThirdPage);
  console.log("Template1 - Es página 4 Caso 8:", isCase8FourthPage);
  console.log("Template1 - Es experiencia+cursos:", isExperiencePlusCourses);
  console.log("Template1 - Es continuación con experiencias:", isContinuationWithExperiences);
  console.log("Template1 - Es página de solo cursos:", isOnlyCoursesPage);
  console.log("Template1 - Hay cursos:", hasCourses);
  console.log("Template1 - Longitud de experiencias:", data.experience?.length || 0);
  console.log("Template1 - Longitud de cursos:", data.courses?.length || 0);

  // Función para renderizar los cursos
  const renderCourses = () => {
    if (!data.courses || data.courses.length === 0) {
      console.log("Template1 - No hay cursos para renderizar");
      return null;
    }
    
    console.log("Template1 - Renderizando cursos:", data.courses.length);
    return (
      <div className="p-4 bg-white/60 backdrop-blur-sm rounded-xl border border-white/40 shadow-lg mb-4">
        <h3 className={`text-lg font-bold mb-3`} style={{ color: colors.accentColor }}>Cursos y Actividades Adicionales</h3>
        <div className="relative">
          {/* Línea vertical que conecta todos los elementos */}
          <div 
            className="absolute left-2 top-0 bottom-0 w-0.5" 
            style={{ backgroundColor: `${colors.accentColor}40` }}
          ></div>
          
          {/* Contenedor para todos los cursos */}
          <div className="space-y-3 ml-10">
            {data.courses.map((course, index) => (
              <div key={`course-${index}`} className="relative">
                {/* Punto en la línea de tiempo */}
                <div 
                  className="absolute -left-10 top-1.5 w-4 h-4 rounded-full border-2"
                  style={{ 
                    backgroundColor: 'white', 
                    borderColor: colors.accentColor 
                  }}
                ></div>
                
                {/* Contenido del curso */}
                <div>
                  <h4 className="font-bold text-gray-800">{course.title}</h4>
                  <div className="flex items-center">
                    <p className={`text-sm`} style={{ color: colors.accentColor }}>{course.institution}</p>
                    <span className={`text-sm mx-2`} style={{ color: colors.accentColor }}>|</span>
                    <p className={`text-sm`} style={{ color: colors.accentColor }}>{course.period}</p>
                  </div>
                  {course.description && (
                    <p className="text-sm text-gray-600 mt-1">{course.description}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  // Determinar si esta página debe mostrar el título de continuación de experiencia
  const shouldShowExperienceContinuationTitle = 
    isContinuationPage && data.experience?.length > 0 && 
    (isCase3ContinuationPage || isCase4ContinuationPage || isCase5SecondPage || 
     isCase6SecondPage || isCase6ThirdPage || isCase7SecondPage || isCase7ThirdPage ||
     isCase8SecondPage || isCase8ThirdPage);
  
  // Determinar si esta página debe mostrar cursos (última página o página específica)
  const shouldShowCourses = hasCourses && 
    (isOnlyCoursesPage || isCase5ThirdPage || isCase6ThirdPage || isCase7ThirdPage || isCase8FourthPage || 
    (isContinuationPage && !isCase5SecondPage && !isCase6SecondPage && !isCase7SecondPage && 
     !isCase8SecondPage && !isCase8ThirdPage));

  // Si es una página solo de cursos (caso 2, caso 5 tercera página o caso 8 cuarta página), solo mostramos los cursos
  if (isOnlyCoursesPage && hasCourses) {
    console.log("Template1 - Renderizando SOLO cursos sin otro contenido");
    return (
      <BaseTemplate
        data={data}
        colors={colors}
        isTemplate1={true}
        renderMainContent={() => (
          <div className="py-6">
            {renderCourses()}
          </div>
        )}
      />
    );
  }
  
  // Si es una página de continuación con experiencias (casos 3, 4, 5, 6, 7 u 8)
  if (isAnyCaseContinuationPage && data.experience && data.experience.length > 0) {
    console.log("Template1 - Renderizando continuación con experiencia");
    
    // Para los casos 5, 6, 7 y 8 (segunda y tercera página), no mostramos los cursos
    const shouldShowCourses = 
      hasCourses && 
      (isCase3ContinuationPage || isCase4ContinuationPage || isCase6ThirdPage || isCase7ThirdPage) && 
      !(isCase5SecondPage || isCase6SecondPage || isCase7SecondPage || 
        isCase8SecondPage || isCase8ThirdPage);
    
    return (
      <BaseTemplate
        data={data}
        colors={colors}
        isTemplate1={true}
        renderMainContent={(experienceItems) => (
          <div className="space-y-5">
            {/* Experiencia laboral (continuación) */}
            {experienceItems && React.Children.count(experienceItems) > 0 && (
              <div className="p-4 bg-white/60 backdrop-blur-sm rounded-xl border border-white/40 shadow-lg mb-5">
                <h3 className={`text-xl font-bold mb-4`} style={{ color: colors.accentColor }}>Experiencia laboral (continuación)</h3>
                <div className="relative">
                  {/* Línea vertical que conecta todos los elementos */}
                  <div 
                    className="absolute left-2 top-0 bottom-0 w-0.5" 
                    style={{ backgroundColor: `${colors.accentColor}40` }}
                  ></div>
                  
                  {/* Contenedor para todas las experiencias */}
                  <div className="space-y-5 ml-10">
                    {React.Children.map(experienceItems, (item, index) => (
                      <div key={`exp-case-${index}`} className="relative">
                        {/* Punto en la línea de tiempo */}
                        <div 
                          className="absolute -left-10 top-1.5 w-4 h-4 rounded-full border-2"
                          style={{ 
                            backgroundColor: 'white', 
                            borderColor: colors.accentColor 
                          }}
                        ></div>
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            
            {/* Cursos y Actividades (para casos específicos) */}
            {shouldShowCourses && renderCourses()}
          </div>
        )}
      />
    );
  }

  return (
    <BaseTemplate
      data={data}
      colors={colors}
      isTemplate1={true}
      renderMainContent={(experienceItems, pageNumber) => (
        <>
          {pageNumber === 1 ? (
            <>
              {/* Encabezado - Optimizado para usar menos espacio vertical */}
              <div className="p-4 bg-white/60 backdrop-blur-sm rounded-xl border border-white/40 shadow-lg mb-4">
                <h1 className="text-2xl font-bold text-gray-800 mb-1">{data.name}</h1>
                <h2 className="text-lg font-bold" style={{ color: colors.accentColor }}>{data.title}</h2>
              </div>

              {/* Educación */}
              {data.education && data.education.length > 0 && (
                <div className="p-4 bg-white/60 backdrop-blur-sm rounded-xl border border-white/40 shadow-lg mb-4">
                  <h3 className={`text-lg font-bold mb-3`} style={{ color: colors.accentColor }}>Educación</h3>
                  <div className="relative">
                    {/* Línea vertical que conecta todos los elementos */}
                    <div 
                      className="absolute left-2 top-0 bottom-0 w-0.5" 
                      style={{ backgroundColor: `${colors.accentColor}40` }}
                    ></div>
                    
                    {/* Contenedor para todos los elementos de educación */}
                    <div className="space-y-3 ml-10">
                      {data.education.map((edu, index) => (
                        <div key={`edu-${index}`} className="relative">
                          {/* Punto en la línea de tiempo */}
                          <div 
                            className="absolute -left-10 top-1.5 w-4 h-4 rounded-full border-2"
                            style={{ 
                              backgroundColor: 'white', 
                              borderColor: colors.accentColor 
                            }}
                          ></div>
                          
                          {/* Contenido de educación */}
                          <div>
                            <h4 className="font-bold text-gray-800">{edu.degree}</h4>
                            <p className={`text-sm`} style={{ color: colors.accentColor }}>{edu.institution} | {edu.period}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Experiencia laboral */}
              <div className="p-4 bg-white/60 backdrop-blur-sm rounded-xl border border-white/40 shadow-lg mb-4">
                <h3 className={`text-lg font-bold mb-3`} style={{ color: colors.accentColor }}>Experiencia laboral</h3>
                <div className="relative">
                  {/* Línea vertical que conecta todos los elementos */}
                  <div 
                    className="absolute left-2 top-0 bottom-0 w-0.5" 
                    style={{ backgroundColor: `${colors.accentColor}40` }}
                  ></div>
                  
                  {/* Contenedor para todas las experiencias */}
                  <div className="space-y-5 ml-10">
                    {React.Children.map(experienceItems, (item, index) => (
                      <div key={`exp-${index}`} className="relative">
                        {/* Punto en la línea de tiempo */}
                        <div 
                          className="absolute -left-10 top-1.5 w-4 h-4 rounded-full border-2"
                          style={{ 
                            backgroundColor: 'white', 
                            borderColor: colors.accentColor 
                          }}
                        ></div>
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {/* Si es otra página, mostramos contenido alternativo según el caso */}
              {/* Experiencia laboral (continuación) */}
              {experienceItems && React.Children.count(experienceItems) > 0 && (
                <div className="p-4 bg-white/60 backdrop-blur-sm rounded-xl border border-white/40 shadow-lg mb-4">
                  <h3 className={`text-lg font-bold mb-3`} style={{ color: colors.accentColor }}>
                    Experiencia laboral (continuación)
                  </h3>
                  <div className="relative">
                    {/* Línea vertical que conecta todos los elementos */}
                    <div 
                      className="absolute left-2 top-0 bottom-0 w-0.5" 
                      style={{ backgroundColor: `${colors.accentColor}40` }}
                    ></div>
                    
                    {/* Contenedor para todas las experiencias */}
                    <div className="space-y-5 ml-10">
                      {React.Children.map(experienceItems, (item, index) => (
                        <div key={`exp-cont-${index}`} className="relative">
                          {/* Punto en la línea de tiempo */}
                          <div 
                            className="absolute -left-10 top-1.5 w-4 h-4 rounded-full border-2"
                            style={{ 
                              backgroundColor: 'white', 
                              borderColor: colors.accentColor 
                            }}
                          ></div>
                          {item}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              
              {/* Cursos y Actividades Adicionales */}
              {hasCourses && !isCase5SecondPage && !isCase6SecondPage && !isCase7SecondPage && 
               !isCase8SecondPage && !isCase8ThirdPage && renderCourses()}
            </>
          )}
        </>
      )}
    />
  );
}